enum PaymentMethod {
  Stripe = "stripe",
  Individual = "individual",
  Free = "free",
}

const UserStatuses = {
  Trial: "trial",
  Active: "active",
  WaitingForPayment: "waiting_for_payment",
  Expiring: "expiring",
  Inactive: "inactive",
} as const;

type UserStatus = (typeof UserStatuses)[keyof typeof UserStatuses];

type WithBannerUserStatus = Exclude<UserStatus, "active">;

enum AccountType {
  Demo = "demo",
  Client = "client",
  Agency = "agency",
  Admin = "admin",
  ServiceRegistration = "service_registration",
}

enum UserRole {
  Owner = "ROLE_OWNER",
  User = "ROLE_USER",
  Demo = "ROLE_DEMO",
  UniversalConsentSolutions = "ROLE_UNIVERSAL_CONSENT_SOLUTIONS",
  Client = "ROLE_CLIENT",
  Agency = "ROLE_AGENCY",
  Admin = "ROLE_ADMIN",
  UserRegistration = "ROLE_USER_REGISTRARTION",
}

enum SubscriptionType {
  Individual = "individual",
  StripeBasedNotStarted = "stripe_based_not_started",
  StripeBasedStarted = "stripe_based_started",
  NotRelated = "not_related",
}

type AuthenticatedUser = {
  iat: number;
  exp: number;
  roles: UserRole[];
  email: string;
  account_id: number;
  account_type: AccountType;
  payment_method: PaymentMethod;
  stripe_customer_id: string | null;
  status: UserStatus;
  stripe_subscription_started: boolean;
  subscription_type: SubscriptionType;
  trial_or_active_period_ends: string | null;
  waiting_for_payment_period_ends: string | null;
  expiring_period_ends: string | null;
  current_user_id: number;
};

export type { AuthenticatedUser, WithBannerUserStatus, UserStatus };
export { PaymentMethod, UserStatuses, AccountType, UserRole, SubscriptionType };
